var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "callout",
        {
          staticClass: "mb-3",
          attrs: {
            "class-main": "bg-secondary-13",
            "class-panel": "p-2",
            "has-toggle": true
          },
          scopedSlots: _vm._u([
            {
              key: "edition",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "p-2 mt-1" },
                    [
                      _vm._l(_vm.value.details, function(row, i) {
                        return _c(
                          "div",
                          {
                            key: `address-item-${i}`,
                            staticClass: "bg-white rounded p-3 row mb-2 mx-0"
                          },
                          [
                            _c("div", { staticClass: "col-12 col-md-3" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "color-secondary-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Número de Cifra: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-normal"
                                },
                                [_vm._v(" " + _vm._s(row.fullNumber) + " ")]
                              )
                            ]),
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "color-secondary-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Line Number: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-normal"
                                },
                                [_vm._v(" " + _vm._s(row.lineNumber) + " ")]
                              )
                            ]),
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "color-secondary-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Line Status: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-normal"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("empty")(row.lineStatus)) +
                                      " "
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "color-secondary-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Merchandise Amount: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-normal"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("price")(row.merchandiseAmount)
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "color-secondary-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" Merchandise VC: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-normal"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("price")(row.merchandiseAmountVC)
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]),
                            _c("div", { staticClass: "col" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "color-secondary-6 font-14 font-weight-normal"
                                },
                                [_vm._v(" DOE Balance Amount: ")]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-normal"
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("price")(row.doeBalanceAmount)
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ])
                          ]
                        )
                      }),
                      _vm.value.details.length == 0
                        ? _c("custom-result-not-found")
                        : _vm._e()
                    ],
                    2
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("div", { staticClass: "row py-2" }, [
            _c("div", { staticClass: "col align-items-center" }, [
              _c("span", { staticClass: "text-gray font-16" }, [
                _vm._v("PO ID:")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-bold" },
                [_vm._v(" " + _vm._s(_vm.value.purchaseOrderId) + " ")]
              )
            ]),
            _c("div", { staticClass: "col align-items-center" }, [
              _c("span", { staticClass: "text-gray font-16" }, [
                _vm._v("Estatus:")
              ]),
              _c(
                "div",
                { staticClass: "color-black font-16 font-weight-bold" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.getStatusDescription(_vm.value.status)) +
                      " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col align-items-center" }, [
              _c("span", { staticClass: "text-gray font-16" }, [
                _vm._v("DOE Balance Amount:")
              ]),
              _c(
                "div",
                {
                  staticClass: "font-16 font-weight-bold",
                  class: _vm.doeBalanceAmountClass
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm._f("price")(_vm.doeBalanceAmount)) + " "
                  )
                ]
              )
            ]),
            _c("div", { staticClass: "col-2 d-flex justify-content-center" }, [
              _c("span", { staticClass: "color-gray-8 font-14 pr-3 mt-1" }, [
                _vm._v(
                  " " + _vm._s(_vm._f("date")(_vm.value.lastUpdatedDate)) + " "
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }